import { useEffect } from 'react'
import { useLocation } from 'react-router'

/** Riporta in cima alla pagina a ogni cambio schermata (pathname), su desktop e mobile.
 *  Lo scroll dell'app avviene sul documento (nessun container interno con overflow),
 *  quindi basta un reset istantaneo di window - niente animazione per non ritardare
 *  la lettura della nuova pagina. Solo pathname (non query): filtri e tab della
 *  stessa pagina non devono far perdere la posizione. */
export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, [pathname])

  return null
}
